import { Injectable } from '@angular/core';
import { AbstractTrackEventsService } from './abstract-track-events.service';

@Injectable()
export class TrackEventsService extends AbstractTrackEventsService {
  trackEvent(event: Record<string, unknown>): void {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);
  }
}
